const GCS_URL_PREFIX = 'https://surveys.statista.com/surveys';

function initGCSLinks() {
    const GCS_REDIRECT_FORM = document.querySelector('#gcs_redirect_form');
    const GCS_REDIRECT_ANCHOR = document.querySelector('[data-gcs-redirect]');
    if (GCS_REDIRECT_ANCHOR) {
        document.querySelectorAll('[data-gcs-result-link]').forEach(gcsLink => {
            const link = gcsLink.dataset.gcsResultLink;
            gcsLink.addEventListener('click', event => {
                if (event.currentTarget) {
                    event.preventDefault();

                    GCS_REDIRECT_ANCHOR.value = link.replace(GCS_URL_PREFIX, '');
                    GCS_REDIRECT_FORM.submit();
                }
            });
            gcsLink.removeAttribute('data-gcs-result-link');
        });
    }
}

export { initGCSLinks };
